export default __webpack_public_path__ + "static/media/PhramacySavedBills.cd476829.svg";